'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _reactI18next = require('react-i18next');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function footerPage(props) {
    var _useTranslation = (0, _reactI18next.useTranslation)('footer'),
        t = _useTranslation.t;

    var page = !(0, _lodash.isEmpty)(t("pages", { returnObjects: true })) && t("pages", { returnObjects: true }).map(function (obj, key) {
        var isExtend = props.selectedKey === key;
        return _react2.default.createElement(
            'li',
            { className: 'float-left col-12 col-lg-auto px-0', key: key, style: props.FooterColStyle },
            _react2.default.createElement(
                'a',
                {
                    className: 'main-page-link foot-link',
                    href: props.returnFullURL(obj.url),
                    style: { cursor: 'pointer' },
                    onClick: function onClick(e) {
                        e.preventDefault();props.onURLClick(obj.url, 'footerMainNav');
                    }
                },
                t('pages.' + key + '.title')
            ),
            obj.subpage.length > 0 && _react2.default.createElement('span', {
                className: 'fa ' + (isExtend ? "fa-angle-up" : "fa-angle-down") + ' d-inline-block d-lg-none',
                style: {
                    marginLeft: 10,
                    opacity: 0.6,
                    minWidth: 50
                },
                onClick: function onClick() {
                    props.toggleFooter(key);
                }
            }),
            obj.subpage.length > 0 && _react2.default.createElement(
                'div',
                { className: (isExtend ? "d-block" : "d-none") + ' d-lg-block' },
                obj.subpage.map(function (item, idx) {
                    return _react2.default.createElement(
                        'div',
                        { key: idx, className: 'py-2 ', style: { paddingRight: 5 } },
                        _react2.default.createElement(
                            'a',
                            {
                                className: 'foot-link'
                                // href={t('pages.' + key + '.subpage.' + idx + '.url')}
                                , href: props.returnFullURL(t('pages.' + key + '.subpage.' + idx + '.url')),

                                style: { cursor: 'pointer' },
                                onClick: function onClick(e) {
                                    e.preventDefault();props.onURLClick(item.url, 'footerSubNav');
                                }
                            },
                            (0, _reactHtmlParser2.default)(t('pages.' + key + '.subpage.' + idx + '.title'))
                        )
                    );
                })
            )
        );
    });
    return _react2.default.createElement(
        'div',
        { className: 'col-12 col-lg-10 d-flex flex-wrap justify-content-start sitemap' },
        _react2.default.createElement(
            'ul',
            { className: 'row px-0 w-100' },
            page
        )
    );
}

exports.default = footerPage;